import { useMediaQuery } from 'usehooks-ts'

import type { ReactNode } from 'react'

type MediaQueryProps = {
  query: string
  children: ReactNode
}

const MediaQuery = ({ query, children }: MediaQueryProps) => {
  const matches = useMediaQuery(query)

  return matches ? <>{children}</> : null
}

export { MediaQuery }
